import RegistersCreate from '@/components/inspections/registers/create/RegistersCreate.vue'

export default {
  name: "RegisterCreatePage",
  components: { RegistersCreate }
};
